import styled from "@emotion/styled";
import { MOBILE_SCREEN } from "../theme";

interface IconContainerProps {
  backgroundColor: string;
  width?: string;
  height?: string;
}

const IconContainer = styled.div<IconContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.width ?? "64px"};
  height: ${(props) => props.height ?? "64px"};
  border-radius: 8px;
  background: ${(props) => props.backgroundColor};
  ${MOBILE_SCREEN} {
    width: ${(props) => (props.width ? props.width : "48px")};
    height: ${(props) => (props.height ? props.height : "48px")};
  }
`;

export default IconContainer;
